<fieldset [formGroup]="group" class="in-one-column">
  <legend class="small-legend">{{ TITLE + "TITLE" | translate }}:</legend>

  <div class="in-two-columns">
    <!-- flavorTypes -->

    <mat-form-field>
      <app-easy-select
        formControlName="flavorTypes"
        [label]="TITLE + 'FLAVOR_TYPES' | translate"
        [translatePrefixForSelected]="'PRODUCTS.FLAVOR_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [multiple]="true"
        [options]="flavorType | toSelectOption: 'PRODUCTS.FLAVOR_TYPE.':true"
      >
      </app-easy-select>
    </mat-form-field>

    <!-- brixValue -->

    <mat-form-field>
      <app-easy-input
        formControlName="brixValue"
        [label]="TITLE + 'BRIX_VALUE' | translate"
        type="number"
        [labelInfo]="TITLE + 'BRIX_INFO' | translate"
      >
      </app-easy-input>
    </mat-form-field>
  </div>

  <!-- containsFruitsOrVegetablesAtLeast50Percent -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsAtLeast25PercentFruitsOrVegetables"
      [label]="
        TITLE + 'CONTAINS_AT_LEAST50_PERCENT_FRUITS_OR_VEGETABLES' | translate
      "
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- containsAtLeast50PercentMilkBasedMaterial -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsAtLeast50PercentMilkBasedMaterial"
      [label]="
        TITLE + 'CONTAINS_AT_LEAST50_PERCENT_MILK_BASED_MATERIAL' | translate
      "
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- frozen -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="frozen"
      [label]="TITLE + 'IS_FROZEN' | translate"
    ></app-easy-checkbox>
  </mat-form-field>

  <!-- netValueEur -->

  <mat-form-field>
    <app-easy-input
      formControlName="netValueEur"
      [label]="TITLE + 'NET_VALUE_EUR' | translate"
      type="number"
      min="0"
      [maxDecimals]="2"
    >
    </app-easy-input>
  </mat-form-field>

  <!-- sugar fields -->

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsAddedSugar"
      [label]="CONTAINS_ADDED_SUGAR | translate"
      (ngModelChange)="onSweetenerOrSugarChangedNonAlcoholic()"
    ></app-easy-checkbox>
  </mat-form-field>

  <mat-form-field>
    <app-easy-checkbox
      formControlName="containsAddedSweetener"
      [label]="CONTAINS_ADDED_SWEETENER | translate"
      (ngModelChange)="onSweetenerOrSugarChangedNonAlcoholic()"
    ></app-easy-checkbox>
  </mat-form-field>

  <div class="in-two-columns">
    <mat-form-field>
      <app-easy-select
        formControlName="sugarContentType"
        [label]="SUGAR_CONTENT_TYPE | translate"
        [translatePrefixForSelected]="'PRODUCTS.SUGAR_CONTENT_TYPE.'"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="nonAlcoholicSugarContentType"
      >
      </app-easy-select>
    </mat-form-field>

    <mat-form-field *ngIf="getCtrl('sugarContentInGramsPerHundredMilliliters')">
      <app-easy-input
        formControlName="sugarContentInGramsPerHundredMilliliters"
        [label]="SUGAR_CONTENT_IN_GRAMS_PER_HUNDRED_MILLILITERS | translate"
        [labelInfo]="'PRODUCTS.SUGAR_CONTENT_FIELDS.INFO' | translate"
        type="number"
        step="1"
        min="0"
        max="100"
      >
      </app-easy-input>
    </mat-form-field>
  </div>

  <!-- !sugar fields -->
</fieldset>
